<template>

  <div>
    <b-row
      class="content-header"
    >

      <!-- Content Left -->
      <b-col
        class="content-header-left mb-2"
        md="6"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h1 class="custom-header-title float-left pr-1 mb-0">
              Customers
            </h1>
          </b-col>
        </b-row>
      </b-col>
      <b-col
        class="content-header-right text-md-right d-md-block d-none mb-1"
        md="6"
        cols="12"
      >
        <!-- <div
          v-if="isExporting"
          class="d-flex justify-content-between mb-1"
        >
          <span>Exporting customers...</span>
          <span>{{ exportProgress }}%</span>
        </div> -->
        <b-button
          v-if="canViewThisAction('export-customers', 'Customer')"
          variant="success"
          @click="exportCustomers"
        >
          <feather-icon
            icon="ExternalLinkIcon"
            class="mr-50"
            size="16"
          />
          <span class="align-middle">Export</span>
        </b-button>
      </b-col>
    </b-row>
    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>
          <b-col
            cols="12"
            md="4"
            class="d-flex align-items-center justify-content-space_between mb-1 mb-md-0"
          >
            <span class="text-muted">Showing {{ dataMeta.from }} - {{ dataMeta.to }} of {{ dataMeta.of }}</span>
          </b-col>
          <!-- Search -->
          <b-col
            cols="12"
            md="8"
          >
            <div class="d-flex align-items-center justify-content-end">
              <a
                href="javascript:void(0)"
                class="nav-link nav-link-search"
                @click="showSearchBar = !showSearchBar"
              >
                <feather-icon
                  icon="SearchIcon"
                  size="21"
                  class="mr-50"
                />
                <span class="align-middle">Search</span>
              </a>
              <b-input-group
                v-if="showSearchBar"
                class="input-group-merge mr-50"
              >
                <b-form-input
                  v-model="searchQuery"
                  placeholder="Customer Name"
                />
                <b-input-group-append is-text>
                  <feather-icon
                    icon="XIcon"
                    class="cursor-pointer"
                    @click="searchQuery = '';"
                  />
                </b-input-group-append>
              </b-input-group>
              <b-input-group
                v-if="showSearchBar"
                class="input-group-merge mr-50"
              >
                <b-form-input
                  v-model="nric"
                  placeholder="NRIC"
                />
                <b-input-group-append is-text>
                  <feather-icon
                    icon="XIcon"
                    class="cursor-pointer"
                    @click="nric = '';"
                  />
                </b-input-group-append>
              </b-input-group>
              <b-input-group
                v-if="showSearchBar"
                class="input-group-merge mr-50"
              >
                <b-form-input
                  v-model="contact"
                  placeholder="Mobile No."
                />
                <b-input-group-append is-text>
                  <feather-icon
                    icon="XIcon"
                    class="cursor-pointer"
                    @click="contact = '';"
                  />
                </b-input-group-append>
              </b-input-group>
              <b-input-group
                v-if="showSearchBar"
                class="input-group-merge mr-50"
              >
                <b-form-input
                  v-model="email"
                  placeholder="Email Address"
                />
                <b-input-group-append is-text>
                  <feather-icon
                    icon="XIcon"
                    class="cursor-pointer"
                    @click="email = '';"
                  />
                </b-input-group-append>
              </b-input-group>

              <b-dropdown
                id="dropdown-form-all-customers"
                ref="filter_dropdown_all_customers"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                class="dropdown-modal"
                right
                variant="link"
              >
                <template #button-content>
                  <feather-icon
                    icon="FilterIcon"
                    size="21"
                    class="align-middle mr-50"
                  />
                  <span class="mr-1">Filters</span>
                </template>
                <customer-filters
                  :customer-type-filter.sync="customerTypeFilter"
                  :customer-source-filter.sync="customerSourceFilter"
                  :created-at-date-filter.sync="createdAtDateFilter"
                  :source-options="sourceOptions"
                  :customer-options="customerOptions"
                  @emitHideFilter="hideFilter"
                  @emitShowFilter="showFilter"
                />
              </b-dropdown>
            </div>
          </b-col>
        </b-row>
        <div v-if="createdAtDateFilter || customerSourceFilter.length || customerTypeFilter.length">
          <hr class="dividerHR filter-divider">
          <b-row>

            <!-- Per Page -->
            <b-col
              cols="12"
              md="12"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <ul
                class="list-inline d-inline-block mb-1"
              >
                <li
                  v-for="sourceVal in customerSourceFilter"
                  :key="sourceVal"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="removeCustomerSourceFilter(sourceVal)"
                  >
                    <span class="text-capitalize">{{ sourceVal }}</span>
                  </b-form-tag>
                </li>
                <li
                  v-for="customerVal in customerTypeFilter"
                  :key="customerVal"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="removeCustomerTypeFilter(customerVal)"
                  >
                    <span class="text-capitalize">{{ customerVal }}</span>
                  </b-form-tag>
                </li>
                <li
                  v-if="createdAtDateFilter"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="createdAtDateFilter = ''"
                  >
                    {{ createdAtDateFilter }}
                  </b-form-tag>
                </li>
                <li
                  class="list-inline-item"
                >
                  <span
                    class="text-danger clear-filter-text mb-50"
                    @click="clearAllFilters"
                  >
                    Clear Filters
                  </span>
                </li>
              </ul>
            </b-col>
          </b-row>
        </div>
      </div>

      <b-table
        ref="refCustomersTable"
        class="position-relative event_list min-height-200"
        :items="fetchCustomers"
        responsive
        :fields="tableColumns"
        primary-key="_id"
        :sort-by.sync="sortBy"
        show-empty
        no-sort-reset
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >
        <template #cell(name)="data">
          <div class="text-nowrap">
            <b-button
              v-if="canViewThisAction('show', 'Customer')"
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="link"
              class="weight-600 align-middle detail-view-id text-uppercase"
              :to="{ name: 'customers-customers-show', params: { id: data.item._id } }"
            >
              {{ data.item.name }}
            </b-button>
            <b-button
              v-else
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="none"
              class="text-bold-black align-middle detail-view-id not-button text-uppercase"
            >
              {{ data.item.name }}
            </b-button>
            <br>
            <span>
              {{ data.item.encryptedNric }}
            </span>
          </div>
        </template>

        <template #cell(emailVerified)="data">
          <span>
            {{ data.item.emailVerified ? 'Yes' : 'No' }}
          </span>
        </template>

        <template #cell(perContact)="data">
          <div class="text-nowrap">
            <span class="">{{ data.item.perContact }}</span>
            <br>
            <span>
              {{ data.item.perEmail || data.item.perEmailSclc }}
            </span>
          </div>
        </template>

        <template #cell(createdAt)="data">
          <div class="text-nowrap">
            <span class="">{{ getCreatedBy(data.item) }}</span>
            <br>
            <span class="">{{ getCreatedAt(data.item) }}</span>
          </div>
        </template>

        <!-- Column: Actions -->
        <template
          v-if="canViewThisAction('show', 'Customer')"
          #cell(actions)="data"
        >
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item
              :to="{ name: 'customers-customers-show', params: { id: data.item._id } }"
            >
              <span class="align-middle ml-50">View</span>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="canViewThisAction('update', 'Customer')"
              :to="{ name: 'customers-customers-edit', params: { id: data.item._id } }"
            >
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
    </b-card>

    <div
      v-if="totalCustomer > perPage"
      class="mx-2 mb-2"
    >
      <b-row>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="12"
          class="d-flex align-items-center justify-content-center pagination-content"
        >

          <b-pagination
            v-show="totalCustomer > customerData.length"
            v-model="currentPage"
            :total-rows="totalCustomer"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            align="center"
            prev-text="Prev"
            next-text="Next"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
              <span>Prev</span>
            </template>
            <template #next-text>
              <span>Next</span>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>

        </b-col>

      </b-row>
    </div>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BTable, BInputGroup, BInputGroupAppend,
  BDropdown, BDropdownItem, BPagination, BButton, BFormTag,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ref, onUnmounted } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useUtils as useAclUtils } from '@/libs/acl/custom'

import store from '@/store'

import useCustomerList from './useCustomerList'
import customerListStoreModule from './customerListStoreModule'
import CustomerFilters from './CustomerFilters.vue'

export default {
  components: {
    // UserListAddNew,
    BButton,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BInputGroup,
    BInputGroupAppend,
    BFormTag,

    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,

    CustomerFilters,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      customerOptions: [
        { label: 'Nirvana SG Users', value: 'Nirvana SG Users' },
        { label: 'Non Nirvana SG Users', value: 'Non Nirvana SG Users' },
      ],
      sourceOptions: [
        { label: 'Nirvana SG', value: 'Nirvana SG' },
        { label: 'SCLC', value: 'SCLC' },
      ],
      isExporting: false,
      exportProgress: 0,
      exportTotalRecords: 0,

      required,
    }
  },

  methods: {
    getCreatedBy(item) {
      if (item.createdByCustomer) {
        return item.createdByCustomer.name
      }
      if (item.createdByNvs) {
        return item.createdByNvs.name
      }
      if (item.createdBy) {
        return item.createdBy
      }

      return ''
    },
    getCreatedAt(item) {
      if (item.createdAtNvs) {
        return this.dateFormatWithTime(item.createdAtNvs)
      }
      if (item.createdAt) {
        return this.dateFormatWithFormatNTZ(item.createdAt, 'DD/MM/YYYY, hh:mma ')
      }

      return ''
    },
    selectAllItems() {
      console.log('ok')
    },
    hideFilter() {
      this.$refs.filter_dropdown_all_customers.hide(true)
    },
    showFilter() {
      this.$refs.filter_dropdown_all_customers.show(true)
    },
    removeCustomerSourceFilter(item) {
      const index = this.customerSourceFilter.indexOf(item)
      if (index > -1) {
        this.customerSourceFilter.splice(index, 1)
      }
    },
    removeCustomerTypeFilter(item) {
      const index = this.customerTypeFilter.indexOf(item)
      if (index > -1) {
        this.customerTypeFilter.splice(index, 1)
      }
    },

    clearAllFilters() {
      this.createdAtDateFilter = ''
      this.customerSourceFilter = []
      this.customerTypeFilter = []
    },
    // exportCustomers() {
    //   this.$http.get('customer/customer/export', {
    //     params: {
    //       search: this.searchQuery,
    //       contact: this.contact,
    //       nric: this.nric,
    //       email: this.email,
    //       sortBy: this.sortBy,
    //       sortDesc: this.isSortDirDesc,
    //       customerSource: this.customerSourceFilter,
    //       customerType: this.customerTypeFilter,
    //       createdAtDate: this.createdAtDateFilter,
    //     },
    //     responseType: 'blob',
    //   })
    //     .then(response => {
    //       const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' })
    //       const url = window.URL.createObjectURL(blob)
    //       const anchor = document.createElement('a')
    //       anchor.href = url
    //       anchor.download = 'customers.csv'
    //       anchor.click()
    //       window.URL.revokeObjectURL(url)
    //     })
    //     .catch(error => {
    //       this.$toast({
    //         component: ToastificationContent,
    //         props: {
    //           title: error.response?.data?.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
    //           icon: 'AlertTriangleIcon',
    //           variant: 'danger',
    //         },
    //       })
    //     })
    // },
    async exportCustomers() {
      this.isExporting = true
      this.exportProgress = 0
      this.exportTotalRecords = 0

      try {
        let page = 0
        let hasMore = true
        let totalRecords = 0
        let processedRecords = 0

        // CSV headers
        const headers = ['ID', 'Customer Name', 'Customer NRIC', 'Contact No.', 'No. of Files',
          'File No. (As Purchaser)', 'Source', 'Nirvana SG User', 'Created By']
        const fields = ['stringID', 'name', 'encryptedNric', 'perContact', 'numberOfFiles',
          'fileNos', 'source', 'nirvanaUser', 'createdByDisplay']

        let csvContent = `${headers.join(',')}\n`
        const chunks = []

        const params = {
          search: this.searchQuery,
          contact: this.contact,
          nric: this.nric,
          email: this.email,
          sortBy: this.sortBy,
          sortDesc: this.isSortDirDesc,
          customerSource: this.customerSourceFilter,
          customerType: this.customerTypeFilter,
          createdAtDate: this.createdAtDateFilter,
        }

        store.commit('appConfig/UPDATE_CONTINUOUS_LOADER', true)

        while (hasMore) {
          // Add page parameter
          params.page = page

          // eslint-disable-next-line no-await-in-loop
          const response = await this.$http.get('customer/customer/export/batch', { params })
          const result = response.data

          if (page === 0) {
            totalRecords = result.totalCount
            this.exportTotalRecords = totalRecords
          }

          if (result.data && result.data.length > 0) {
            // Convert batch to CSV rows
            // eslint-disable-next-line no-loop-func
            result.data.forEach(row => {
              const values = fields.map(field => {
                let value = row[field] || ''
                // Escape quotes and wrap in quotes if contains comma, quote, or newline
                if (typeof value === 'string' && (value.includes(',') || value.includes('"') || value.includes('\n'))) {
                  value = `"${value.replace(/"/g, '""')}"`
                }
                return value
              })
              csvContent += `${values.join(',')}\n`
            })

            processedRecords += result.data.length

            // Store chunks to avoid memory issues with very large strings
            if (csvContent.length > 1000000) { // 1MB chunks
              chunks.push(csvContent)
              csvContent = ''
            }

            // Update progress
            this.exportProgress = Math.round((processedRecords / totalRecords) * 100)
          }

          hasMore = result.hasMore

          // Turn off continuous loader after the last request completes
          // (when hasMore becomes false, the loop will end after this iteration)
          if (!hasMore) {
            store.commit('appConfig/UPDATE_CONTINUOUS_LOADER', false)
            store.commit('appConfig/UPDATE_LOADER', false)
          }

          // eslint-disable-next-line no-plusplus
          page++

          // Small delay to prevent overwhelming the server
          // eslint-disable-next-line no-await-in-loop
          await new Promise(resolve => setTimeout(resolve, 50))
        }

        // Add remaining content
        if (csvContent) {
          chunks.push(csvContent)
        }

        // Create blob from chunks and download
        const blob = new Blob(chunks, { type: 'text/csv;charset=utf-8;' })
        const url = window.URL.createObjectURL(blob)
        const anchor = document.createElement('a')
        anchor.href = url
        anchor.download = 'customers.csv'
        anchor.style.display = 'none'
        document.body.appendChild(anchor)
        anchor.click()
        document.body.removeChild(anchor)
        window.URL.revokeObjectURL(url)

        this.$toast({
          component: ToastificationContent,
          props: {
            title: `Export completed successfully! ${processedRecords} records exported.`,
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
      } catch (error) {
        console.error('Export error:', error)
        // Turn off continuous loader in case of error
        store.commit('appConfig/UPDATE_CONTINUOUS_LOADER', false)

        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.response?.data?.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isExporting = false
        this.exportProgress = 0
        this.exportTotalRecords = 0
      }
    },
  },
  setup() {
    const showSearchBar = ref(false)
    const showFilterOptions = ref(false)
    const CUSTOMER_APP_STORE_MODULE_NAME = 'app-all-customers'

    // Register module
    if (!store.hasModule(CUSTOMER_APP_STORE_MODULE_NAME)) store.registerModule(CUSTOMER_APP_STORE_MODULE_NAME, customerListStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(CUSTOMER_APP_STORE_MODULE_NAME)) store.unregisterModule(CUSTOMER_APP_STORE_MODULE_NAME)
    })

    const { canViewThisAction } = useAclUtils()

    const {
      fetchCustomers,
      tableColumns,
      perPage,
      currentPage,
      totalCustomer,
      customerData,
      dataMeta,
      perPageOptions,
      searchQuery,
      contact,
      nric,
      email,
      sortBy,
      isSortDirDesc,
      refCustomersTable,
      refetchData,

      // Extra Filters
      customerSourceFilter,
      customerTypeFilter,
      createdAtDateFilter,
    } = useCustomerList()

    return {
      // Sidebar
      fetchCustomers,
      tableColumns,
      perPage,
      currentPage,
      totalCustomer,
      dataMeta,
      perPageOptions,
      searchQuery,
      contact,
      nric,
      email,
      sortBy,
      isSortDirDesc,
      refCustomersTable,
      refetchData,
      showSearchBar,
      showFilterOptions,
      customerData,

      // Filter
      avatarText,
      canViewThisAction,

      // Extra Filters
      customerSourceFilter,
      customerTypeFilter,
      createdAtDateFilter,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.dropdown__left-align-adjust{
  ul{
     left: 100% !important;
  }
}
.dropdown__left-align-adjust-mobile{
  ul{
     left: 50% !important;
  }
}
</style>
